// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentDetailsText_container__DNwFC","paymentType":"PaymentDetailsText_paymentType__nMBM0","cardType":"PaymentDetailsText_cardType__KKZe5"};